import { render, staticRenderFns } from "./CostBearerEducationTheoryLessonPreview.vue?vue&type=template&id=eb404090"
import script from "./CostBearerEducationTheoryLessonPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerEducationTheoryLessonPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports